import { CallToAction } from 'components/CallToAction';
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { prepareData } from 'utils/googleData';
import Link from 'components/Link'


const BlogColumn = ({ children }) => {
    return <div className="md:border-r last:border-r-0 border-dashed border-gray-accent-light">{children}</div>;
};

const BlogItem = ({ name, url }) => {
    return (
        <li className="list-none m-0 pt-2 px-1 pb-3 text-[15px] w-full font-semibold border-gray-accent-light/50 border-solid border-b last:border-b-0">
            {url ? (
                <Link to={url}>
                    {name}
                    </Link>
            ) : (
                name
            )}
        </li>
    );
};

export default function Blog(props) {
    const { enable, title, subtitle, homeBlogTitle, description, cta, direction, style, gatsbyImage, sections, gatsbyImage2 } = prepareData({ props });
    
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>;
    }
    
    return (
        <div className="px-4 mb-20 max-w-7xl mx-auto md:grid md:grid-cols-3 md:gap-12">
            <figure className="w-64 mt-20 mx-auto md:w-auto">
                <GatsbyImage
                    width={367}
                    height={348}
                    imgClassName=""
                    placeholder="blurred"
                    alt={`Here's what's cookin', good lookin'`}
                    image={gatsbyImage}
                />
            </figure>
            <div dir={direction} className="col-span-2">
                <h2 className="m-0 text-5xl md:text-7xl text-primary text-center md:text-left"
                    dangerouslySetInnerHTML={{ __html: homeBlogTitle?.title }}>
                </h2>
                <h3 className="m-0 text-lg md:text-[20px] leading-tight md:text-xl font-semibold mt-2 md:mt-3 opacity-75 text-primary">
                    {homeBlogTitle?.subtitle}
                </h3>

                <div className="mt-4 mb-12">
                    <CallToAction type="outline" to={cta?.url}>
                        {cta?.text}
                    </CallToAction>
                </div>

                <div className="grid md:grid-cols-2 relative after:bg-gradient-to-b after:from-tan/0 after:to-white/70 md:after:to-white/90 after:bottom-0 after:left-0 after:w-full after:h-36 after:absolute">
                    {sections?.length > 0 && sections.map((section, index) => {
                        const { name, description, items, style = '' } = section;
                        return (
                            <BlogColumn key={index}>
                                <div key={index} className="text-base py-1 font-bold text-center dark:text-blue bg-gray-accent-light">
                                    {name}
                                </div>
                                <ul key={index} className="m-0 px-4 pt-1 dark:text-blue bg-white">
                                    {items?.length > 0 && items.map((item, index2) => (
                                        <BlogItem key={index2} name={item?.name} url={item?.url} />
                                    ))}
                                </ul>
                            </BlogColumn>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
